import { combineReducers } from "redux";
import AgentEvaluationsReducer from "./AgentEvaluationsDuck";

let QAAgentReducers = combineReducers({
  AgentEvaluations: AgentEvaluationsReducer,
});

export default QAAgentReducers;
